export default __webpack_public_path__ + "479fdb81cb6936ad24a6f9f847be198c.otf";